import { SITE_PHOTOS } from '../lib/siteAssets';

export const BUILTIN_PHOTO_PLACEMENTS = [
  'team-hakan',
  'about-story',
  'gallery',
  'hero-background',
  'unassigned',
] as const;

export type BuiltInPhotoPlacement = typeof BUILTIN_PHOTO_PLACEMENTS[number];
export type PhotoPlacement = string;

export interface SitePhoto {
  id: string;
  url: string;
  caption: string;
  description: string;
  placement: PhotoPlacement;
  active: boolean;
  addedAt: string;
}

export const mockPhotos: SitePhoto[] = [
  {
    id: 'photo-01',
    url: SITE_PHOTOS.photo01,
    caption: 'Hakan Zobu – Professional Portrait',
    description: '',
    placement: 'team-hakan',
    active: true,
    addedAt: '2025-01-10',
  },
  {
    id: 'photo-02',
    url: SITE_PHOTOS.photo02,
    caption: 'Hakan Zobu – Advisory Session',
    description: '',
    placement: 'about-story',
    active: true,
    addedAt: '2025-01-10',
  },
  {
    id: 'photo-03',
    url: SITE_PHOTOS.photo03,
    caption: 'Strategy Workshop – Client Engagement',
    description: 'A focused strategy workshop bringing together senior leadership and our consulting team. Together we mapped out a comprehensive transformation roadmap, identifying key performance gaps and prioritising initiatives for maximum impact across the organisation.',
    placement: 'gallery',
    active: true,
    addedAt: '2025-01-10',
  },
  {
    id: 'photo-04',
    url: SITE_PHOTOS.photo04,
    caption: 'Presentation – Regional Development Forum',
    description: 'Hakan Zobu presenting at the Regional Development Forum, sharing insights on sustainable industrial growth and investment strategies. The session drew delegates from across Turkey and neighbouring markets, sparking meaningful dialogue on policy alignment.',
    placement: 'gallery',
    active: true,
    addedAt: '2025-01-10',
  },
  {
    id: 'photo-05',
    url: SITE_PHOTOS.photo05,
    caption: 'Consulting Session – Industrial Client',
    description: 'An in-depth consulting engagement with a leading industrial client, reviewing operational efficiency metrics and supply chain performance. Our team worked closely with the client\'s management to develop tailored solutions aligned with long-term business goals.',
    placement: 'gallery',
    active: true,
    addedAt: '2025-01-10',
  },
  {
    id: 'photo-06',
    url: SITE_PHOTOS.photo06,
    caption: 'Field Visit – Site Assessment (2015)',
    description: 'An early field visit capturing one of our first major on-site assessments in 2015. This project marked a turning point in how we approach industrial due diligence — combining quantitative analysis with direct observation to deliver reliable, actionable findings.',
    placement: 'gallery',
    active: true,
    addedAt: '2025-01-10',
  },
  {
    id: 'photo-07',
    url: SITE_PHOTOS.photo07,
    caption: 'Panel Discussion – Policy Forum',
    description: 'Contributing to a high-level policy forum panel focused on economic competitiveness and foreign investment attraction. Zobu Consulting was invited as a practitioner voice, offering real-world perspective from years of advisory work across diverse sectors.',
    placement: 'gallery',
    active: true,
    addedAt: '2025-01-10',
  },
];

export const PLACEMENT_LABELS: Record<BuiltInPhotoPlacement, string> = {
  'team-hakan': 'Team – Hakan Zobu Portrait',
  'about-story': 'About Page – Story Section',
  'gallery': 'About Page – Photo Gallery',
  'hero-background': 'Hero Background',
  'unassigned': 'Unassigned',
};

export function isBuiltInPhotoPlacement(value: string): value is BuiltInPhotoPlacement {
  return BUILTIN_PHOTO_PLACEMENTS.includes(value as BuiltInPhotoPlacement);
}

export function getPhotoPlacementLabel(value: string) {
  const trimmedValue = value.trim();

  if (trimmedValue === '') {
    return 'No placement';
  }

  if (isBuiltInPhotoPlacement(trimmedValue)) {
    return PLACEMENT_LABELS[trimmedValue];
  }

  return trimmedValue;
}
